module.exports = __webpack_public_path__ + "static/media/payment-faq-section-title-arrow.17b45b05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment-faq-section-title-arrow.svg
// module id = 2066
// module chunks = 0